// Tiny localStorage shim for the last care team the user selected.
//
// Used to make the sidebar "Home" nav land on `/team/<that-programid>`
// instead of `/` (which would re-trigger the picker). Written every
// time the URL is `/team/:programid/…`, read when the user clicks the
// home icon from a non-team route (engage / financial / /).
//
// One value, one key, defensive try/catch — no need for a store.

const STORAGE_KEY = 'rpm_last_programid';

export function getLastSelectedProgramId(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setLastSelectedProgramId(programid: string | number): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(programid));
  } catch {
    // Ignore — storage may be unavailable (Safari private mode, quota,
    // etc.). The home nav falls back to `/` which re-triggers the picker.
  }
}
